import { MdArrowDropDown } from "react-icons/md";
import { useState } from "react";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@/components/ui/select";

export const DropDown = ({ handler, selected }) => {
  const colorMap = {
    pending: "text-yellow-700",
    approved: "text-green-700",
    rejected: "text-red-700",
  };
  const titles = ["Rejected", "Approved"];

  return (
    <Select
      value={selected}
      onValueChange={handler}
    >
      <SelectTrigger className={`w-full min-w-[6rem] h-9 border border-zinc-200 rounded-md px-2 py-1 text-xs bg-zinc-50 focus:outline-none focus:ring-2 focus:ring-orange-200 transition shadow-none flex items-center gap-2 ${colorMap[selected]}`}>
        <SelectValue placeholder="Status">
          {<span className={`${colorMap[selected.toLowerCase()]} capitalize`} >{selected} </span> || "Status"}
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="rounded-md shadow-md border border-zinc-100 bg-white text-xs min-w-[6rem]">
        {titles.map((title) => (
          <SelectItem
            key={title}
            value={title}
            className={`capitalize cursor-pointer rounded ${colorMap[title.toLowerCase()]} `}
          >
            {title}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};